import { render } from "./ProductForm.vue?vue&type=template&id=43ea6989&scoped=true&ts=true"
import script from "./ProductForm.vue?vue&type=script&lang=ts"
export * from "./ProductForm.vue?vue&type=script&lang=ts"

import "./ProductForm.vue?vue&type=style&index=0&id=43ea6989&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ea6989"]])

export default __exports__